// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"3a1b24e3","78":"bb445c34","355":"37e6f5e7","396":"05fe05ae","441":"e55773da","551":"6a47025c","662":"198c9fa1","809":"77e0cab2","856":"652220ad","936":"7f093609","967":"352185d9"}[chunkId] + ".chunk.js";
};